import { ApiResponse } from "../../apiResponse";
import Axios from "../../axios";

export function bookingSession(
  data: object | undefined,
  token: string | number,
  date: string | undefined,
  timeSeconds: string | undefined
): Promise<ApiResponse> {
  return Axios.post(`v1/learners/schedules`, data, {
    params: {
      date: date,
      start_time: timeSeconds,
      learner_token: token,
    },
  });
}
